import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Positioning extends BaseOption {
  static userInterfaceComponent = {
    label: "Positioning",
    component: inspectorTools.POSITION_DIRECTION_INPUT,
    useCustomLabel: true,
    // canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      options: ["relative", "absolute", "sticky"],
    },
  };

  static defaultValue = { position: null, top: null, bottom: null, right: null, left: null };

  static convertConfigValueToCompiledValue(configValue) {
    if (!configValue || typeof configValue !== "object") {
      configValue = this.defaultValue;
    }

    let { position, top, bottom, right, left } = configValue;
    if (!position) {
      position = "static";
    }

    return {
      position,
      top: this.getPositionByPixelValue(top),
      bottom: this.getPositionByPixelValue(bottom),
      left: this.getPositionByPixelValue(left),
      right: this.getPositionByPixelValue(right),
    };
  }

  static getPositionByPixelValue(pixelValue) {
    if (pixelValue === undefined || pixelValue === null || isNaN(pixelValue)) {
      return "unset";
    }
    return `${pixelValue}px`;
  }

  get getPositionByPixelValue() {
    return this.constructor.getPositionByPixelValue;
  }
}
